module.exports = __webpack_public_path__ + "static/img/18.4cee23c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imges/18.jpg
// module id = JS+Y
// module chunks = 1